module.exports = __webpack_public_path__ + "static/media/035.a56f3add.jpg";